// src/plugins/hubspot-widget.js
export default {
  install(Vue) {
    Vue.prototype.$loadHubSpotWidget = function() {
      const scriptId = 'hs-script-loader';
      // Verificar si el script ya está cargado
      if (!document.getElementById(scriptId)) {
        const hubSpotScript = document.createElement("script");
        hubSpotScript.type = "text/javascript";
        hubSpotScript.id = scriptId;
        hubSpotScript.async = true;
        hubSpotScript.defer = true;
        hubSpotScript.src = "//js-na1.hs-scripts.com/49506804.js";  // URL del script de HubSpot
        document.body.appendChild(hubSpotScript);
      }
    };

    // Cargar el widget cuando el plugin se instale
    Vue.prototype.$loadHubSpotWidget();
  }
};
